import moment from "moment";
import auth from "../../server/auth";
import location from "../../server/location";

const layoutStore = {
  namespaced: true,
  state: () => ({
    requestsPending: 0,
    loading: false,
    alert: false,
    currentUser: {},
    location: {}
  }),
  mutations: {
    setRequestsPending(state, newValue) {
      state.requestsPending = newValue;
    },
    async setLoading(state, newValue) {
      state.loading = newValue;
    },
    async setAlert(state, alert) {
      state.alert = alert;
    },
    setUser: (state, user) => (state.currentUser = user),
    setLocation: (state, location) => (state.location = location)
  },
  actions: {
    show({ commit }) {
      commit("setLoading", true);
    },
    showAlertError({ commit, dispatch, state }, { message }) {
      commit("setAlert", {
        type: "error",
        message
      });
      if (message == "Error!") {
        setTimeout(() => {
          if (state.alert && state.alert.message == "Error!") {
            dispatch("hideAlert");
          }
        }, 5000);
      }
    },
    hideAlert({ commit }) {
      commit("setAlert", null);
    },
    async fetchCurrentUser({ commit }) {
      const currentUser = await auth.getCurrentUser();
      if (currentUser !== null) {
        commit("setUser", currentUser);
        location.get(currentUser.locationId).then(location => {
          commit("setLocation", location);
        });
      }
    }
  },
  getters: {
    user: state => state.currentUser,
    getCurrentAdjustedDateTime: state => () => {
      const currentMomentUtc = moment(
        moment
          .utc()
          .format()
          .slice(0, -1)
      );
      const curentLocation = state.location;
      const currentMomentAdjusted = currentMomentUtc.add(
        curentLocation?.timeZoneHoursShift,
        "hours"
      );
      return currentMomentAdjusted.toDate();
    }
  }
};

export default layoutStore;
